const searchClient = {
  path: '/utilities',
  component: () => import('@/views/pages/Utilities/UtilitiesRoute.vue'),
  meta: { layout: 'content' },
  children: [
    {
      path: 'home',
      name: 'utilities-home',
      component: () => import('@/views/pages/Utilities/Marketing/Media/display/DisplayMedia.vue'),
      meta: {
        layout: 'content',
      },
    },
    {
      path: 'parts-order',
      name: 'parts-order',
      component: () => import('@/views/pages/sgqSystem/PastsOrder/home.vue'),
      meta: {
        layout: 'content',
      },
    },
    {
      path: 'reviews',
      name: 'reviews',
      component: () => import('@/views/pages/Utilities/Reviews/home.vue'),
      meta: { layout: 'content' },
    },
    {
      path: 'nexus-status',
      name: 'nexus-status',
      component: () => import('@/views/pages/Utilities/NexusStatus/index.vue'),
      meta: { layout: 'content' },
    },
    {
      path: 'customer-service',
      name: 'customer-service',
      component: () => import('@/views/pages/Utilities/CustomerService/home.vue'),
      meta: { layout: 'content' },
    },
    {
      path: 'customer-service-list',
      name: 'customer-service-list',
      component: () => import('@/views/pages/Utilities/CustomerService/ListAttending.vue'),
      meta: { layout: 'content' },
    },
    {
      path: 'logs-success',
      name: 'logs-success',
      component: () => import('@/views/pages/Utilities/Logs/tabs/Success/LogsSucces.vue'),
      meta: {
        layout: 'content',
      },
    },
    {
      path: 'logs-error',
      name: 'logs-error',
      component: () => import('@/views/pages/Utilities/Logs/tabs/Error/LogsError.vue'),
      meta: {
        layout: 'content',
      },
    },
    {
      path: 'insert-media',
      name: 'insert-media',
      component: () => import('@/views/pages/Utilities/Marketing/Media/insert-media/InsertMedia.vue'),
      meta: {
        layout: 'content',
      },
    },
    {
      path: 'display-media',
      name: 'display-media',
      component: () => import('@/views/pages/Utilities/Marketing/Media/display/DisplayMedia.vue'),
      meta: {
        layout: 'content',
      },
    },
    {
      path: 'integrations-reprocessing',
      name: 'integrations-reprocessing',
      component: () => import('@/views/pages/Utilities/ReprocessingPlan/index.vue'),
      meta: {
        layout: 'content',
      },
    },
    {
      path: 'black-list',
      name: 'black-list',
      component: () => import('@/views/pages/Utilities/BlackListPlan/index.vue'),
      meta: {
        layout: 'content',
      },
    },
    {
      path: 'auto-force-catalog-motoca',
      name: 'auto-force-catalog-motoca',
      component: () => import('@/views/pages/Utilities/AutoForce/CatalogoMotoca/index.vue'),
      meta: {
        layout: 'content',
      },
    },
    {
      path: 'auto-force-catalog-fuji',
      name: 'auto-force-catalog-fuji',
      component: () => import('@/views/pages/Utilities/AutoForce/CatalogoFuji/index.vue'),
      meta: {
        layout: 'content',
      },
    },

    {
      path: 'review_detail/:periode',
      name: 'review_detail',
      component: () => import('@/views/pages/Utilities/Reviews/tabs/firstReview.vue'),
      meta: {
        layout: 'content',
      },
    },
  ],
}

export default searchClient
